import type { AgentGroup, AgentOption, PendingFollowup } from './types';

export function deriveAgents(followups: PendingFollowup[]): AgentOption[] {
  const byId = new Map<string, string>();
  for (const f of followups) {
    if (!f.created_by_user_id) continue;
    if (!byId.has(f.created_by_user_id)) {
      byId.set(f.created_by_user_id, f.created_by_user_name || 'Unknown');
    }
  }
  return Array.from(byId.entries())
    .map(([id, name]) => ({ id, name }))
    .sort((a, b) => a.name.localeCompare(b.name, 'de'));
}

/** Group while preserving backend order within each agent. */
export function groupByAgent(followups: PendingFollowup[]): AgentGroup[] {
  const map = new Map<string, AgentGroup>();
  for (const f of followups) {
    const key = f.created_by_user_id || 'unknown';
    let group = map.get(key);
    if (!group) {
      group = {
        userId: key,
        userName: f.created_by_user_name || 'Unknown',
        tasks: [],
        overdueCount: 0,
      };
      map.set(key, group);
    }
    group.tasks.push(f);
    if (f.is_overdue) group.overdueCount += 1;
  }
  return Array.from(map.values()).sort((a, b) =>
    a.userName.localeCompare(b.userName, 'de')
  );
}

export function formatGroupHeader(group: AgentGroup): string {
  const taskLabel = group.tasks.length === 1 ? 'task' : 'tasks';
  const overdue =
    group.overdueCount > 0 ? ` (${group.overdueCount} overdue)` : '';
  return `${group.userName} · ${group.tasks.length} ${taskLabel}${overdue}`;
}
